export const RECEIVE_ARTICLE_FEEDBACK = 'RECEIVE_ARTICLE_FEEDBACK';
export const POST_USER_FEEDBACK = 'POST_USER_FEEDBACK';
export const DELETE_USER_FEEDBACK = 'DELETE_USER_FEEDBACK';
